<template>
  <component
    :is="divOrTable"
    :class="{'table table-bordered table-fixed-header noborderdisabled valigntop' : tableCell}"
  >
    <component :is="divOrTbody">
      <component :is="divOrTr" :class="{'row': !tableCell}">
        <component :is="divOrTd" :class="{'col col-4' : !tableCell}" class="wojewodztwoselect">
          <w-select
            :model="model.Wojewodztwo"
            :values="wojSelect"
            @input="$emit('wojChanged',  model, pow, gmi)"
            :label="!tableCell"
          ></w-select>
        </component>
        <component :is="divOrTd" class="powiatselect" :class="{'col col-4' : !tableCell}">
          <w-select
            :model="model.Powiat"
            :values="powSelect"
            @input="$emit('powChanged', model, pow, gmi)"
            :label="!tableCell"
          ></w-select>
        </component>
        <component :is="divOrTd" class="gminaselect" :class="{'col col-4' : !tableCell}">
          <w-select
            :model="model.Gmina"
            :values="gmiSelect"
            @input="$emit('gmiChanged', model, pow, gmi)"
            :label="!tableCell"
          ></w-select>
        </component>
      </component>
      <component :is="divOrTr" :class="{'row': !tableCell}">
        <component :is="divOrTd" :class="{'col col-4' : !tableCell}">
          <w-input :model="model.KodPocztowy" :setTitleAsPlaceholder="tableCell"></w-input>
        </component>
        <component :is="divOrTd" :class="{'col col-4' : !tableCell}">
          <w-input :model="model.Poczta" :setTitleAsPlaceholder="tableCell"></w-input>
        </component>
        <component :is="divOrTd" :class="{'col col-4' : !tableCell}">
          <w-input :model="model.Miejscowosc" :setTitleAsPlaceholder="tableCell"></w-input>
        </component>
      </component>
      <component :is="divOrTr" :class="{'row': !tableCell}">
        <component :is="divOrTd" :class="{'col col-4' : !tableCell}">
          <w-input :model="model.Ulica" :setTitleAsPlaceholder="tableCell"></w-input>
        </component>
        <component :is="divOrTd" :class="{'col col-4' : !tableCell}">
          <w-input :model="model.Nr" :setTitleAsPlaceholder="tableCell"></w-input>
        </component>
        <component :is="divOrTd" :class="{'col col-4' : !tableCell}">
          <w-input :model="model.NumerLokalu" :setTitleAsPlaceholder="tableCell"></w-input>
        </component>
      </component>
    </component>
  </component>
</template>
<style scoped>
table {
  width: 100%;
  border: 0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
}
</style>
<script>
import WInput from '../../components/input.vue';
import WSelect from '../../components/select.vue';

export default {
  name: 'w-address',
  props: {
    tableCell: {
      // td parent tego componentu powinien mieć class="input border-0" style="padding:0!important;"
      type: Boolean,
      default: false
    },
    model: Object,
    woj: Array
  },
  data() {
    return {
      pow: [],
      gmi: []
    };
  },
  mounted() {
    this.$emit('wojChanged', this.model, this.pow, this.gmi);
    this.$emit('powChanged', this.model, this.pow, this.gmi);
  },
  components: {
    WInput,
    WSelect
  },
  computed: {
    wojSelect: {
      get() {
        return [
          {text: 'Województwo', value: '', disabled: true},
          ...this.woj.map(x => {
            return {
              value: x,
              text: x
            };
          })
        ];
      }
    },
    powSelect: {
      get() {
        const tmp = [];
        if (this.model.Powiat.$model) {
          tmp.push({text: this.model.Powiat.$model, value: this.model.Powiat.$model});
        } else {
          tmp.push({text: 'Powiat', value: '', disabled: true});
        }
        return [
          ...tmp,
          ...this.pow.map(x => {
            return {
              value: x,
              text: x
            };
          })
        ];
      }
    },
    gmiSelect: {
      get() {
        const tmp = [];
        if (this.model.Gmina.$model) {
          tmp.push({text: this.model.Gmina.$model, value: this.model.Gmina.$model});
        } else {
          tmp.push({text: 'Gmina', value: '', disabled: true});
        }

        return [
          ...tmp,
          ...this.gmi.map(x => {
            return {
              value: x,
              text: x
            };
          })
        ];
      }
    },
    divOrTd() {
      return this.tableCell ? 'td' : 'div';
    },
    divOrTr() {
      return this.tableCell ? 'tr' : 'div';
    },
    divOrTable() {
      return this.tableCell ? 'table' : 'div';
    },
    divOrTbody() {
      return this.tableCell ? 'tbody' : 'div';
    }
  }
};
</script>
<style scoped>
td {
  width: Calc(100% / 3);
}
</style>
